<div class="mb-4 flex items-center justify-between">
  <h3 class="text-base font-semibold text-gray-900 dark:text-gray-100">Payout Requests</h3>
  <div class="flex items-center gap-3">
    <dojo-payment-request-status-filter
      [statusFilter]="statusFilter()"
      (statusFilterChanged)="updateAgGridStatusFilters($event)"
    />
    <dojo-button
      [fill]="'solid'"
      [size]="'s'"
      [disabled]="state.hourlyRate === null || !state.canLogWorkingHours"
      (click)="openWorkingHoursDialog()"
    >
      <dojo-icon [icon]="'plus'" class="mr-2" />
      Log Working Hours
    </dojo-button>
  </div>
</div>

<div class="flex flex-1 flex-col overflow-hidden rounded-xl bg-white dark:bg-gray-800">
  <dojo-master-list-view
    [class]="'h-full w-full'"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [canAdd]="false"
    [showToolbarAddButton]="false"
    [hideSearch]="true"
    [messages]="{
      noDataHeader: 'No payout requests found',
      noDataBody: 'Start logging your working hours to create a payout request'
    }"
    (gridReady)="onGridReady($event)"
  />
</div>
